import { SHOW_MODAL, HIDE_MODAL } from '../types';

const initialState = {
  modalType: null,
  isOpened: false,
  instance: null,
};

const sessionTimeOutModalReducer = (state = initialState, action) => {
  switch (action.type) {
  case SHOW_MODAL:
    return {
      modalType: action.modalType,
      isOpened: true,
      instance: action.instance,
    };
  case HIDE_MODAL:
    return initialState;
  default:
    return state;
  }
};

export default sessionTimeOutModalReducer;
